export class TableContextOverview {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "metrics",
            "baseName": "metrics",
            "type": "Array<TableContextMetric>",
            "format": ""
        },
        {
            "name": "rejectedMetrics",
            "baseName": "rejectedMetrics",
            "type": "Array<TableContextRejectedMetric>",
            "format": ""
        },
        {
            "name": "groupBy",
            "baseName": "groupBy",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "groupByEdit",
            "baseName": "groupByEdit",
            "type": "TableContextEdit",
            "format": ""
        },
        {
            "name": "segmentBy",
            "baseName": "segmentBy",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "segmentByEdit",
            "baseName": "segmentByEdit",
            "type": "TableContextEdit",
            "format": ""
        },
        {
            "name": "leftOut",
            "baseName": "leftOut",
            "type": "Array<TableContextLeftOut>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableContextOverview.attributeTypeMap;
    }
    constructor() {
    }
}
